var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70031 0C7.35606 0 6.06687 0.534001 5.11634 1.48453C4.16582 2.43505 3.63182 3.72425 3.63182 5.06849V7.89041H0.919488C0.783308 7.89041 0.672913 8.00081 0.672913 8.13699V11.863C0.672913 11.9992 0.783308 12.1096 0.919488 12.1096H3.63182V19.7534C3.63182 19.8896 3.74221 20 3.87839 20H7.60442C7.7406 20 7.85099 19.8896 7.85099 19.7534V12.1096H10.5873C10.7005 12.1096 10.7991 12.0326 10.8266 11.9228L11.7581 8.19679C11.797 8.04116 11.6793 7.89041 11.5189 7.89041H7.85099V5.06849C7.85099 4.84324 7.94048 4.62721 8.09975 4.46794C8.25903 4.30866 8.47506 4.21918 8.70031 4.21918H11.5496C11.6858 4.21918 11.7962 4.10878 11.7962 3.9726V0.246575C11.7962 0.110396 11.6858 0 11.5496 0H8.70031Z",
    fill: "#D93D2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.567c1bbd4a0e93ec3f7df19eccc83521.svg";
export { ForwardRef as ReactComponent };